import { FC, useEffect, useState } from "react";
import "./privacy.css";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import useAuth from "../../../hooks/useAuth";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { Loading } from "../../../components/Loading";
import Swal from "sweetalert2";
import { useAppConfig } from "../../../hooks/useAppConfig"; // <-- Adicionado

const Privacy: FC = () => {
  const [termo, setTermo] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getToken } = usePluginspace();
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();
  const { loginInfo } = useAuth();

  // Estados para a Cor Primária
  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  const atualizar = async () => {
    setLoading(true);

    await api
      .put(
        `/api/customer/${loginInfo.id}`,
        {
          optinWhatsapp: termo,
          addresses: [],
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then((response) => {
        setLoading(false);
        const update = response.data;
        if (update.success) {
          Swal.fire({
            icon: "success",
            title: "Sucesso!",
            text: "Preferências atualizadas com sucesso.",
            confirmButtonColor: primaryColor,
          }).then(() => navigate(`/${pluginspace_id}/profile`));
        } else {
          Swal.fire({
            icon: "error",
            title: "Erro ao salvar!",
            text: "Não foi possível atualizar suas preferências.",
            confirmButtonColor: primaryColor,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao salvar!",
          text: "Não foi possível atualizar suas preferências.",
          confirmButtonColor: primaryColor,
        });
      });
  };

  const getCustomerConfig = async () => {
    setLoading(true);
    try {
      // 1. Pega a cor principal
      const conf = await getAppConfig();
      if (conf?.webappcolor?.webappbutton) {
        setPrimaryColor(conf.webappcolor.webappbutton);
      }

      // 2. Busca a preferência do usuário
      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: loginInfo.identifier,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response: any) => {
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setTermo(data.optinWhatsapp);
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCustomerConfig();
  }, [loginInfo.identifier]);

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#FFF",
            zIndex: 10,
          }}
        >
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="perfil-privacy-content">
          <div className="perfil-privacy-header">
            <h2>Configurações da conta</h2>
          </div>

          <div className="perfil-privacy-inputs">
            {/* WhatsApp */}
            <div className="perfil-privacy-checkbox">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={termo}
                  onChange={(event) => setTermo(event.target.checked)}
                />
                {/* O background color injetado aqui faz o switch assumir a cor da loja quando ativo */}
                <span
                  className="slider"
                  style={{ backgroundColor: termo ? primaryColor : "" }}
                ></span>
              </label>
              <div>
                <span>Aceito receber mensagem via WhatsApp</span>
              </div>
            </div>

            <button
              className="perfil-privacy-btn"
              style={{ background: primaryColor }}
              onClick={() => atualizar()}
            >
              Salvar preferências
            </button>
          </div>

          {/* Área de Exclusão */}
          <div className="perfil-privacy-excluir">
            <div className="perfil-privacy-excluir-header">
              <h4>Excluir conta</h4>
            </div>
            <div className="perfil-privacy-excluir-content">
              <span>
                <button
                  id="linkButton"
                  style={{ color: primaryColor }}
                  onClick={() => navigate("delete")}
                >
                  Clique aqui{" "}
                </button>{" "}
                para visualizar os termos de encerramento e solicitar a exclusão
                definitiva da sua conta.
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { Privacy };
